import React from 'react';
import Box from '@mui/material/Box';

export default function GrayBorder() {
  return <Box className="border-t border-gray-02 mx-24  max-md:mx-0 mt-4 max-md:mt-8 mb-6 max-md:mb-5" />;
}
